import { jsx as _jsx } from "react/jsx-runtime";
import Button from "../Button";
import "./PrimaryButton.css";
const PrimaryButton = (props) => {
    return (_jsx(Button, Object.assign({}, props, { className: "primary-button" })));
};
export default PrimaryButton;
